export default "__VITE_ASSET__IW5BdTFD__"